import React, { useEffect, useState } from "react";

import { Button } from "antd";

import DatePicker from "../../../../Common/DatePicker/DatePicker";
import { exportCoaSamplesToExcel } from "./exportCoaSamplesToExcel";

// FUTURE PROD: Re-enable named-file download popup (ExportCOADownloadModal) when custom file name is required.
// import ExportCOADownloadModal from "./ExportCOADownloadModal";
// import { ReactComponent as WhiteArrowDown } from "../../../../../assets/images/chevron-down.svg";
// import { ReactComponent as WhiteArrowUp } from "../../../../../assets/images/chevron-up.svg";

import "./ExportCOAModal.css";

export default function ExportCOAModalHeader({
  handleToggleAllFilterDrawer, setDateSelected, dateSelected, filteredSamples, dates,
}) {
  const [disableDownloadBtn, setDisableDownloadBtn] = useState(false);

  // FUTURE PROD: Toggle for ExportCOADownloadModal popup.
  // const [showDownloadModal, setShowDownloadModal] = useState(false);
  // const toggleDownloadModal = () => {
  //   setShowDownloadModal(!showDownloadModal);
  // };

  useEffect(() => { setDisableDownloadBtn(Object.keys(filteredSamples).length === 0); }, [filteredSamples]);

  /** Direct download — same export as modal, default file name (no popup). */
  const handleDirectDownload = () => {
    exportCoaSamplesToExcel(filteredSamples);
  };

  const getDates = async () => new Promise((resolve) => {
    setTimeout(() => {
      resolve(dates);
    }, 1000); // Simulating a 1 second delay
  });

  (async () => {
    await getDates();
  })();

  return (
    <div>
      <div className="ExportCOAModalHeader">
        <Button type="default" className="ExportCOAModalHeader__AllFilter__Icon" onClick={handleToggleAllFilterDrawer}>
          All
        </Button>
        <div className="ExportCOAModalHeader__DatePicker">
          <DatePicker
            searchOnClear={false}
            popoverPlacement="bottomRight"
            popoverClassName="EnvCalendarPopover"
            datePickerDisplayProps={{
              iconTooltipTitle: "Sort by date",
              // displayClassName: "ExportCOAModalHeader__DatePicker",
            }}
            prevValue={dateSelected}
            value={dateSelected}
            setPrevValue={(val) => setDateSelected(val)}
            getReportDates={getDates}
            showClearBtn={false}
          />
        </div>
        <Button
          type="primary"
          className="ExportCOAModalHeader__Download__btn"
          onClick={handleDirectDownload}
          disabled={disableDownloadBtn}
        >
          Download
        </Button>
        {/*
          FUTURE PROD: Download button opens name-input modal instead of direct export.
          <Button
            type="primary"
            className="ExportCOAModalHeader__Download__btn"
            onClick={toggleDownloadModal}
            disabled={disableDownloadBtn}
          >
            Download
            {!showDownloadModal ? <WhiteArrowDown stroke={disableDownloadBtn ? "#afbdca" : "#FFF"} /> : <WhiteArrowUp />}
          </Button>
          {showDownloadModal && <ExportCOADownloadModal filteredSamples={filteredSamples} />}
        */}
      </div>
    </div>
  );
}
